import mergeWith from 'lodash.mergewith';

// NOTE secluding this function due to usage of lodash.mergeWith
// talked to philip and came up with plan to do perf tickets later
// tickets maybe to use `just-<func>` packages OR refactor our code where able

const mergeWithArrayMerge = (obj1, obj2) => {
  if (Array.isArray(obj1)) {
    return [...obj1, ...obj2];
  }
};

const deepStateMerge =
  ({ state, nextState, keysToExclude, keysToMergeArrays }) =>
  (prev, curr) => {
    const mergeFunction = keysToMergeArrays.includes(curr) ? mergeWithArrayMerge : undefined;

    const merged = mergeWith({}, state?.[curr] || {}, nextState[curr] || {}, mergeFunction);

    return {
      ...prev,
      [curr]: keysToExclude.includes(curr) ? nextState[curr] : merged,
    };
  };

export default deepStateMerge;
